import React, { useEffect, useState } from 'react';
import { IncreaseBalanceApprovalService } from 'services';
import { Button } from 'components/ui/form';

import FileForm from '../file-form';
import styles from './balance.module.scss';

const Balance = ({ contract: { balance, id } }) => {
  const [files, setFiles] = useState(null);
  useEffect(() => {
    (async () => {
      const resp = await new IncreaseBalanceApprovalService().getApprovals();
      if (resp.length) {
        setFiles(resp.filter(file => file.contractId === id)
          .map(file => ({ ...JSON.parse(file.file[0]) })));
      }
    })();
  }, [id]);

  const addFile = (file) => {
    setFiles([...files, { ...JSON.parse(file.file[0]) }]);
  };

  return (

    <>
      <div className={styles.balance}>
        <div className={styles.name}>
          {balance}
          {' '}
          руб
        </div>
        <ul className={styles.list}>
          <li>Статические данные</li>
          <li>Пополнение №460 от 20.02.2019</li>
          <li>Пополнение №457 от 20.02.2019</li>
          <li>Пополнение №340 от 20.02.2019</li>
          <li>Оплат счета №45963749374 от 20.02.2019</li>
          <li>Оплата счета №768 от 25.01.2019</li>
          <li>Пополнение №123 от 20.02.2019</li>
          <li>Оплата счет №123 от 20.02.2019</li>
        </ul>
      </div>
      <p>Прикрепленные файлы оплаты:</p>
      {files && (
      <ul className={styles.list}>
        {files.map(file => (
          <li key={file.id}>
            <a href={file.link} download rel="noopener noreferrer" target="_blank">{file.originalName}</a>
          </li>
        ))}
      </ul>
      )}
      <FileForm contractId={id} addFile={addFile} />
      <div>
        <Button color="lightgray">Все операции</Button>
      </div>
    </>
  );
};

export default Balance;
